import React from 'react';

const IconArrowDown = () => {
  return (
    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.38806 0.180869L16.8068 13.5996L17.7312 2.51096L21.2183 2.80052L19.8583 19.126L3.53285 20.486L3.24329 16.9989L14.332 16.0745L0.913191 2.65574L3.38806 0.180869Z"
        fill="#8C0367"
      />
    </svg>
  );
};

export default IconArrowDown;
